import { getTenantById } from "@/api/tenantDashboardService";
import React, { createContext, useState, useContext, useEffect } from "react";

type TenantContextType = {
  tenantName: string;
  setTenantName: (name: string) => void;
};

const TenantContext = createContext<TenantContextType>({
  tenantName: "",
  setTenantName: () => {},
});

export const TenantProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [tenantName, setTenantName] = useState<string>("");

  const loadTenantName = async (tenantId: string) => {
    const tenant = await getTenantById(tenantId, {});
    const name = tenant?.name || "";
    setTenantName(name);
    localStorage.setItem("tenantName", name);
  };

  useEffect(() => {
    const tenantId = localStorage.getItem("tenantId");
    if (tenantId) {
      loadTenantName(tenantId);
    }
  }, []);

  const handleSetTenantName = (name: string) => {
    localStorage.setItem("tenantName", name);
    setTenantName(name);
  };

  return (
    <TenantContext.Provider
      value={{ tenantName, setTenantName: handleSetTenantName }}
    >
      {children}
    </TenantContext.Provider>
  );
};

export const useTenantContext = () => useContext(TenantContext);
